const CustomerRequest = ({ customer }) => {

    if (!customer?.user_request) {
        return (
            <p>
                <pre>{'{}'}</pre>
            </p>
        );
    }

    return (
        <p>
            <pre>{JSON.stringify(customer.user_request, undefined, 4)}</pre>
        </p>
    );
};

export { CustomerRequest };
